<button
  [type]="type()"
  [disabled]="disabled()"
  [class]="'app-button ' + variant() + (disabled() ? ' disabled' : '')"
>
  <ng-content></ng-content>
</button>
